export default {"src":"/_next/static/media/finansfabrikenLogoBeige.ba9b90e8.svg","height":35,"width":26,"blurWidth":0,"blurHeight":0};